/**
 * Disable all GSAP animations for better UX
 * Keep only essential interactions
 */

// Override GSAP if it exists
if (typeof gsap !== 'undefined') {
    // Kill all animations
    gsap.globalTimeline.clear();
    
    // Disable ScrollTrigger
    if (gsap.plugins.ScrollTrigger) {
        gsap.plugins.ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        gsap.plugins.ScrollTrigger.disable();
    }
    
    // Set all animated elements to their final state
    document.querySelectorAll('.gsap-fade-up, .gsap-fade-in, .gsap-slide-in, .gsap-scale-in').forEach(el => {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.visibility = 'visible';
    });
}

// Remove animation classes
document.addEventListener('DOMContentLoaded', () => {
    // Remove all animation classes
    const animationClasses = [
        'gsap-fade-up',
        'gsap-fade-in', 
        'gsap-slide-in',
        'gsap-scale-in',
        'fade-in',
        'fade-up',
        'floating',
        'pulse'
    ];
    
    animationClasses.forEach(className => {
        document.querySelectorAll('.' + className).forEach(el => {
            el.classList.remove(className);
            el.style.opacity = '1';
            el.style.transform = 'none';
        });
    });
    
    // Mark body as loaded to prevent any delayed animations
    document.body.classList.add('loaded');
    
    // Ensure all sections are visible
    document.querySelectorAll('.section, .hero-slide-content, .process-step').forEach(el => {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.visibility = 'visible';
    });
});

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {};
}